import _class_call_check from "@swc/helpers/src/_class_call_check.mjs";
import _to_consumable_array from "@swc/helpers/src/_to_consumable_array.mjs";
export var LogLevel;
(function(LogLevel) {
    LogLevel[LogLevel["ALL"] = 1] = "ALL";
    LogLevel[LogLevel["TRACE"] = 2] = "TRACE";
    LogLevel[LogLevel["DEBUG"] = 3] = "DEBUG";
    LogLevel[LogLevel["INFO"] = 4] = "INFO";
    LogLevel[LogLevel["WARNING"] = 5] = "WARNING";
    LogLevel[LogLevel["ERROR"] = 6] = "ERROR";
    LogLevel[LogLevel["NONE"] = 7] = "NONE";
})(LogLevel || (LogLevel = {}));
var LoggerService = /*#__PURE__*/ function() {
    "use strict";
    function LoggerService() {
        _class_call_check(this, LoggerService);
        var envLevel = process.env["NX_LOGGER_LEVEL"] || "ALL";
        this.level = LogLevel[envLevel];
    }
    var _proto = LoggerService.prototype;
    /**
   * Invoke the message logger based on "ALL" severity
   * @param message - messages to be printed
   */ _proto.log = function log() {
        for(var _len = arguments.length, message = new Array(_len), _key = 0; _key < _len; _key++){
            message[_key] = arguments[_key];
        }
        this.logMessage.apply(this, [
            LogLevel.ALL
        ].concat(_to_consumable_array(message)));
    };
    /**
   * Invoke the message logger based on "INFO" severity
   * @param message - messages to be printed
   */ _proto.info = function info() {
        for(var _len = arguments.length, message = new Array(_len), _key = 0; _key < _len; _key++){
            message[_key] = arguments[_key];
        }
        this.logMessage.apply(this, [
            LogLevel.INFO
        ].concat(_to_consumable_array(message)));
    };
    /**
   * Invoke the message logger based on "TRACE" severity
   * @param message - messages to be printed
   */ _proto.trace = function trace() {
        for(var _len = arguments.length, message = new Array(_len), _key = 0; _key < _len; _key++){
            message[_key] = arguments[_key];
        }
        this.logMessage.apply(this, [
            LogLevel.TRACE
        ].concat(_to_consumable_array(message)));
    };
    /**
   * Invoke the message logger based on "WARNING" severity
   * @param message - messages to be printed
   */ _proto.warn = function warn() {
        for(var _len = arguments.length, message = new Array(_len), _key = 0; _key < _len; _key++){
            message[_key] = arguments[_key];
        }
        this.logMessage.apply(this, [
            LogLevel.WARNING
        ].concat(_to_consumable_array(message)));
    };
    /**
   * Invoke the message logger based on "ERROR" severity
   * @param message - messages to be printed
   */ _proto.error = function error() {
        for(var _len = arguments.length, message = new Array(_len), _key = 0; _key < _len; _key++){
            message[_key] = arguments[_key];
        }
        this.logMessage.apply(this, [
            LogLevel.ERROR
        ].concat(_to_consumable_array(message)));
    };
    /**
   * Invoke the message logger based on "DEBUG" severity
   * @param message - messages to be printed
   */ _proto.debug = function debug() {
        for(var _len = arguments.length, message = new Array(_len), _key = 0; _key < _len; _key++){
            message[_key] = arguments[_key];
        }
        this.logMessage.apply(this, [
            LogLevel.DEBUG
        ].concat(_to_consumable_array(message)));
    };
    /**
   * Format the whole date
   */ _proto.formatMessage = function formatMessage(logLevel) {
        var ref;
        return "".concat(this.formatDate(), " | Level: ").concat((ref = LogLevel[logLevel]) === null || ref === void 0 ? void 0 : ref.toUpperCase(), " |");
    };
    /**
   * Format the whole date
   * @returns the formatted date
   */ _proto.formatDate = function formatDate() {
        var date = new Date();
        var fullYear = this.adjustDateFormat(date.getUTCFullYear());
        var UTCDate = this.adjustDateFormat(date.getUTCDate());
        var month = this.adjustDateFormat(date.getUTCMonth() + 1);
        var hours = this.adjustDateFormat(date.getHours());
        var minutes = this.adjustDateFormat(date.getMinutes());
        var seconds = this.adjustDateFormat(date.getSeconds());
        var milliseconds = this.adjustDateFormat(date.getMilliseconds());
        return "".concat(fullYear, "-").concat(UTCDate, "-").concat(month, " ").concat(hours, ":").concat(minutes, ":").concat(seconds, ":").concat(milliseconds);
    };
    /**
   * Adjust date section formatting
   * @param logLevel - severity of the log
   * @param messages - messages to be printed
   */ _proto.logMessage = function logMessage(logLevel) {
        for(var _len = arguments.length, messages = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            messages[_key - 1] = arguments[_key];
        }
        if (logLevel >= this.level && logLevel !== LogLevel.NONE) {
            if (logLevel === LogLevel.WARNING) {
                var _console;
                (_console = console).warn.apply(_console, [
                    this.formatMessage(logLevel)
                ].concat(_to_consumable_array(messages)));
            } else if (logLevel === LogLevel.ERROR) {
                var _console1;
                (_console1 = console).error.apply(_console1, [
                    this.formatMessage(logLevel)
                ].concat(_to_consumable_array(messages)));
            } else if (logLevel === LogLevel.DEBUG) {
                var _console2;
                (_console2 = console).debug.apply(_console2, [
                    this.formatMessage(logLevel)
                ].concat(_to_consumable_array(messages)));
            } else if (logLevel === LogLevel.INFO) {
                var _console3;
                (_console3 = console).info.apply(_console3, [
                    this.formatMessage(logLevel)
                ].concat(_to_consumable_array(messages)));
            } else {
                var _console4;
                (_console4 = console).log.apply(_console4, [
                    this.formatMessage(logLevel)
                ].concat(_to_consumable_array(messages)));
            }
        }
    };
    /**
   * Adjust date section formatting
   * @param input - date section to be formatted
   * @returns the date section adjusted
   */ // eslint-disable-next-line class-methods-use-this
    _proto.adjustDateFormat = function adjustDateFormat(input) {
        return input < 10 ? "0".concat(input) : String(input);
    };
    return LoggerService;
}();
var LoggerInstance = new LoggerService();
export { LoggerService, LoggerInstance };
